var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "right-sidebar-open elevation-2",
      attrs: { column: "", "justify-start": "", "fill-height": "" }
    },
    [
      _c(
        "v-layout",
        { staticClass: "py-2", attrs: { row: "", "justify-start": "" } },
        [
          _c("div", { staticClass: "layertitleTextContainer" }, [
            _c("span", { staticClass: "layerTitle" }, [
              _vm._v(_vm._s(_vm.$tc("" + _vm.sidebarOpen, 2)))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("right-sidebar-layers", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.sidebarOpen === "layers",
            expression: "sidebarOpen === 'layers'"
          }
        ]
      }),
      _vm._v(" "),
      _vm.sidebarOpen === "tools" ? _c("right-sidebar-tools") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fafb4710", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fafb4710","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/RightSidebar/RightSidebarOpen.vue
// module id = null
// module chunks = 